import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs/operators';

declare let gtag: (...args: unknown[]) => void;

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly _platformId = inject(PLATFORM_ID);
  private readonly _router = inject(Router);

  init(): void {
    if (!isPlatformBrowser(this._platformId)) return;

    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        const navEnd = event as NavigationEnd;
        if (typeof gtag !== 'undefined') {
          gtag('config', 'G-E6HL05EKTX', { page_path: navEnd.urlAfterRedirects });
        }
      });
  }
}
